module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/TK3_WkUHHAIjg75cFRf3bXL8LICs1_FvsUhiYySUhiCXABTV.fc991048.woff";